var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTwitterOriginal = function SvgTwitterOriginal(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#149ce8",
    d: "M19.999 4.012a8 8 0 0 1-2.357.676 4.28 4.28 0 0 0 1.804-2.375c-.805.5-1.686.852-2.605 1.041a4.05 4.05 0 0 0-2.328-1.305 3.95 3.95 0 0 0-2.605.45 4.22 4.22 0 0 0-1.804 2.019 4.47 4.47 0 0 0-.254 2.75 11.25 11.25 0 0 1-4.686-1.3A11.8 11.8 0 0 1 1.39 2.785a4.46 4.46 0 0 0-.45 3.129 4.3 4.3 0 0 0 1.723 2.6 3.95 3.95 0 0 1-1.86-.536v.055c.001.99.33 1.95.93 2.718a4.08 4.08 0 0 0 2.362 1.489 3.94 3.94 0 0 1-1.854.073c.262.853.773 1.6 1.46 2.134a4 4 0 0 0 2.374.848 8.1 8.1 0 0 1-2.868 1.52A7.9 7.9 0 0 1 0 17.07 11.24 11.24 0 0 0 6.29 19c7.548 0 11.675-6.54 11.675-12.212q0-.28-.012-.556a8.6 8.6 0 0 0 2.046-2.22"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTwitterOriginal);
export { ForwardRef as ReactComponent };